<template>
  <div class="w-full h-full">
    <div ref="editorPane" class="editor-pane bg-gray-100" @click="handleClickCanvas" @keyup.esc="handleKeyup">
      <div class="editor-pane-inner">
        <div class="editor-main" :style="{transform: 'scale('+scale+')'}">
          <div id="canvas-panel" ref="canvas-panel" class="page-preview-wrapper bg-white">
            <!--页面组件列表展示-->
            <template v-if="readonly">
              <div
                v-for="item in elements"
                :key="item.id"
                :style="getCommonStyle({width: item.commonStyle.width, height: item.commonStyle.height, left: item.commonStyle.left,top: item.commonStyle.top,position: item.commonStyle.position})"
                class="flex flex-col group"
              >
                <div class="container-header flex justify-between">
                  <div class="header-title" style="color: rgb(31, 45, 61);">{{ item.title }}</div>
                </div>
                <component
                  :is="item.elName"
                  class="element-on-edit-pane flex-1"
                  v-bind="{ height:item.commonStyle.height - 30, width: item.commonStyle.width, query: value.filter(_item => _item.id === item.id)[0]}"
                />
              </div>
            </template>
            <template v-else>
              <editor-shape
                v-for="item in elements"
                :key="item.id"
                :uuid="item.id"
                :default-style="item.commonStyle"
                :style="getCommonStyle({width: item.commonStyle.width, height: item.commonStyle.height, left: item.commonStyle.left,top: item.commonStyle.top,position: item.commonStyle.position})"
                :active="item.id === activeElementUUID"
                class="flex flex-col group"
                @handleElementClick="handleElementClick(item.id)"
                @resize="handleElementResize"
              >
                <div class="container-header flex justify-between">
                  <div class="header-title" style="color: rgb(31, 45, 61);">{{ item.title }}</div>
                  <div class="invisible cursor-pointer group-hover:visible" @mousedown.stop>
                    <i class="bi bi-gear" @click="onEdit(item)" />
                    <i class="bi bi-trash" @click="onDelete(item)" />
                  </div>
                </div>
                <component
                  :is="item.elName"
                  class="element-on-edit-pane flex-1"
                  v-bind="{ height:item.commonStyle.height - 30, width: item.commonStyle.width, query: item.query}"
                />
              </editor-shape>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {_qk_register_components_object} from '../plugins/index'
import editorShape from '../edit-shape'
import editorProjectConfig from '../DataModel'
import {plugins} from '../uitls'
import _ from 'lodash'

// todo 测试用
// window._qk_register_components_object = _qk_register_components_object
export default {
  components: {
    // 批量注册qk组件
    ..._qk_register_components_object,
    // 画板组件
    editorShape,
  },

  props: {
    value: {
      type: Array,
      default: () => {
        []
      },
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    // canvas画板缩放
    scale: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      dialogVisible: false,
      elements: this.value.map(item => {
        let newItem = _.clone(item)
        newItem.query = {
          filter: item.filter,
          fields: item.fields,
          form: item.form,
          id: item.id,
        }
        newItem.elName = plugins[newItem.type]
        newItem.commonStyle = {
          ...editorProjectConfig.elementConfig.commonStyle,
          left: newItem.x,
          top: newItem.y,
          width: newItem.width,
          height: newItem.height,
        }
        console.log(newItem)

        return newItem
      }),
      commonStyle: editorProjectConfig.elementConfig.commonStyle,
      getCommonStyle: editorProjectConfig.getCommonStyle,
      editorPaneWidth: 0,
      projectData: {},
      // 画板中选中的元素uuid
      activeElementUUID: '',
      // 历史操作数据用于undo redo
      historyCache: [],
      // redo undo 指针
      currentHistoryIndex: -1,
      activeAttrEditCollapse: ['1'],
      activeElementIndex: 0,
      currentPageIndex: 0,
    }
  },
  computed: {
    result() {
      return this.elements.map(item => {
        // console.log('result', item)
        let element = _.clone(item)
        element.type = Object.keys(plugins).find(key => plugins[key] === item.elName)
        element.x = element.commonStyle.left
        element.y = element.commonStyle.top
        element.width = element.commonStyle.width
        element.height = element.commonStyle.height
        delete element.commonStyle
        delete element.elName
        return element
      })
    },
    // ...mapState({
    //   projectData: state => state.editor.projectData,
    //   activePageUUID: state => state.editor.activePageUUID,
    //   activeElementUUID: state => state.editor.activeElementUUID,
    // }),
    // ...mapGetters([
    //   'currentPageIndex',
    //   'activeElementIndex',
    //   'activeElement',
    //   'activePage',
    // ]),
  },
  watch: {
    value(newVal) {
      // console.log('editor-panel watch value', newVal)
    },
    dialogVisible(newVal) {
      // console.log('dialogVisible', newVal)
    },
    // elements(newVal) {
    //   console.log('editor-panel watch elements', newVal)
    //   this.$emit('input', newVal)
    // },
  },
  mounted() {
    this.editorPaneWidth = this.$refs.editorPane.offsetWidth
    // this.editorPaneWidth = 1240
    // console.log('editor panel mounted', this.$refs.editorPane.offsetWidth)
  },
  methods: {
    onEdit(item) {
      let element = this.value.find(el => el.id === item.id)
      this.$emit('edit', element)
    },
    onDelete(item) {
      this.elements.splice(this.elements.indexOf(item), 1)
      this.$emit('input', this.result)
    },
    /**
     * 元素被点击
     * @param uuid
     */
    handleElementClick(uuid) {
      // this.$store.dispatch('setActiveElementUUID', uuid)
      console.log('handleElementClick', uuid)
      this.activeElementUUID = uuid
      this.activeElementIndex = this.elements.findIndex(item => item.id === uuid)
    },
    /**
     * 移动改变元素大小定位
     * @param pos 当pos有值表示移动中需要实时同步样式变化，pos为undefind时则表示移动结束，记一次历史纪录
     * 鼠标移动完成时才记入历史纪录
     */
    handleElementResize(pos) {
      // console.log('handleElementResize', pos)
      if (!pos) {
        // this.$store.dispatch('addHistoryCache')
        return
      }
      if (pos.left < 0) {
        pos.left = 0
      }
      if (pos.top < 0) {
        pos.top = 0
      }
      if (pos.left + pos.width > this.editorPaneWidth) {
        pos.left = this.editorPaneWidth - pos.width
      }
      this.elements[this.activeElementIndex].commonStyle.left = pos.left
      // 更新元素commonStyle
      this.elements[this.activeElementIndex].commonStyle = {
        ...pos,
      }
      this.$emit('input', this.result)

      // debounce(() => {
      //   console.log('handleElementResize debounce', pos)
      //   this.$emit('input', this.result)
      // } , 0)

    },
    handleClickCanvas(e) {
      console.log('handleClickCanvas', e)
      if (!e.target.classList.contains('element-on-edit-pane') && !e.target.classList.contains('menu-item-on-edit-panel')) {
        // this.$store.dispatch('setActiveElementUUID', '')
        this.activeElementUUID = ''
      }
    },
    /**
     * 对元素进行操作命令
     */
    handleElementCommand(command) {
      // this.$store.dispatch('elementCommand', command)
    },
    /**
     * 监听键盘事件
     * @param e
     */
    handleKeyup(e) {
      console.log(1111, e)
    },
    /**
     * 提供截屏作为项目主图
     */
    screenshots() {
      // const el = document.querySelector('#canvas-panel')
      // html2canvas(el, {
      //   width:375,
      //   height:667,
      //   proxy: '/htmltocanvas/corsproxy', // 设置跨域接口
      // }).then(canvas => {
      //   let url=canvas.toDataURL('image/jpeg')
      //   this.$store.commit('updateCoverImage', url)
      // })
    },
  },
}
</script>

<style lang="scss" scoped>
.editor-pane {
  height: 100%;
  width: 100%;
  border-width: 0 1px;
  //background-image: linear-gradient(45deg, #f5f5f5 25%, transparent 0, transparent 75%, #f5f5f5 0), linear-gradient(45deg, #f5f5f5 25%, transparent 0, transparent 75%, #f5f5f5 0);
  background-position: 0 0, 13px 13px;
  background-size: 26px 26px;
  display: flex;
  justify-content: center;
}

.editor-pane-inner {
  height: 100%;
  width: 100%;
  overflow: auto;
  //padding: 20px;
}

.editor-main {
  border-radius: 3px;
  box-shadow: 0 3px 10px #dcdcdc;
  //margin: 25px auto;
  margin: auto;
  position: relative;
  background: white;
  transform-origin: center top;
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZAgMAAAC5h23wAAAAAXNSR0IB2cksfwAAAAlQTFRF9fX18PDwAAAABQ8/pgAAAAN0Uk5T/yIA41y2EwAAABhJREFUeJxjYIAC0VAQcGCQWgUCDUONBgDH8Fwzu33LswAAAABJRU5ErkJggg==");
}

.page-preview-wrapper {
  height: 100%;
  position: relative;
}

.page-wrapper-mask {
  height: 100%;
  width: 100%;
  z-index: 1000;
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
  outline: rgba(236, 238, 240, 0.77) solid 10000px;
}

.element-on-edit-pane {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.page-wrapper-menu-operation {
  position: absolute;
  right: 0;
  top: 45px;
  width: 0;
  background: white;
  color: #333;
  text-align: center;
  z-index: 1002;
  border-radius: 4px;
  display: none;
  transition: all 0.28s;
  opacity: 0;

  .menu-item {
    padding: 10px;
    cursor: pointer;

    &.i {
      font-size: 24px;
      line-height: 30px;
    }

    &:hover {
      background: rgba(37, 165, 137, 0.09);
      color: #25A589;

      &.i {
        font-weight: bold;
        font-size: 26px;
      }
    }
  }

  &.active {
    display: block;
    width: 60px;
    opacity: 1;
  }
}

.container-header {
  background: rgb(255, 255, 255);
  height: 30px;
  line-height: 30px;

  .header-title {
    padding: 0 5px;
    font-weight: 700;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

</style>
